import { create } from "zustand";

interface InitialState {
  id: string;
  isDirty: boolean;
  isSubmitting: boolean;
  isModalOpen: boolean;
}

interface Actions {
  setId: (id: string) => void;
  setDirty: (isDirty: boolean) => void;
  setSubmitting: (isSubmitting: boolean) => void;
  setModal: (isModalOpen: boolean) => void;
  reset: () => void;
}

const initialState: InitialState = {
  id: "",
  isDirty: false,
  isSubmitting: false,
  isModalOpen: false,
};

export const useFormContext = create<InitialState & Actions>((set) => ({
  ...initialState,
  setId: (id: string) => set({ id }),
  setDirty: (isDirty: boolean) => set({ isDirty }),
  setSubmitting: (isSubmitting: boolean) => set({ isSubmitting }),
  setModal: (isModalOpen: boolean) => set({ isModalOpen }),
  reset: () => set(initialState),
}));
